var ComponentsClass = (function () {
    function ComponentsClass() {
    }
    return ComponentsClass;
}());
//# sourceMappingURL=ComponentsClass.js.map